import "./PlainControl.css"
import adaptiveSize from './../../utils/size'

export default function PlainControl(props) {

    const onClick = props.onClick
    const id = props.id
    const text = props.children
    const width = props.width
    const resolutionUnit = props.resolutionUnit;
    const fontSize = adaptiveSize(resolutionUnit, 1.6);
    const padding = adaptiveSize(resolutionUnit, 0.6);
    const extraClassName = props.className ?? "";
    const className = (["plain-control", extraClassName]).join(" ");

    let backgroundColor
    let foregroundColor
    if (props.hasOwnProperty("backgroundColor")) {
        backgroundColor = props.backgroundColor
    } else {
        backgroundColor = "#F5EF81"
    }
    if (props.hasOwnProperty("foregroundColor")) {
        foregroundColor = props.foregroundColor
    } else {
        foregroundColor = "#17151E"
    }

    const style = {
        backgroundColor: backgroundColor,
        color: foregroundColor,
        width: width,
        fontSize: `${fontSize}px`,
        padding: `${padding}px`
    }
    return (
        <button
            onClick={() => {onClick(id)}}
            style={style}
            className={className}
        >
            {text}
        </button>
    );
}